import { useState, useEffect } from "react";
import { throttle } from "throttle-debounce";

const useInteraction = (initial, OnInteraction) => {
	const [value, setValue] = useState(initial);

	const checkScrollTop = throttle(200, () => {
		if (window.pageYOffset > 0) {
			setValue(OnInteraction);
			window.removeEventListener("scroll", checkScrollTop);
		}
	});

	useEffect(() => {
		window.addEventListener("scroll", checkScrollTop);

		return () => {
			window.removeEventListener("scroll", checkScrollTop);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return value;
};

export default useInteraction;
export { useInteraction };
